import { atom } from "jotai";
import { getActivities, getConstructionProgress } from "../../services/dashboard";
import { getInstallStatsDownloadReport, getInstallStatsReport, getSummarizedInventoryData, getSummaryData, getTrackerData, getBlockNames, getPartDetails, getBomRequiredBlockWise, getScopeData } from "../../services/reports/index";


const reportsAtoms = atom({
    constructionList: {},
    progressList: [],
    summaryData: [],
    statsData: [],
    summarizedInventoryData:[],
    trackerData: [],
    blockNames: {},
    partsData: [],
    partDetails: {},
    scopeData: []
});

export const getScopeList = atom(
    null,
    async (get, set, args) => {
        try {
            const res = await getScopeData(args);
            if (res) {
                set(reportsAtoms, (prev) => {
                    return { ...prev, scopeData: res.data };
                });
            }
        } catch (error) {
            console.error('Error fetching construction progress:', error);
        }
    }
);

export const getActivity = atom(
    null,
    async (get, set) => {
        try {
            const res = await getActivities();
            if (res) {
                set(reportsAtoms, (prev) => {
                    return { ...prev, constructionList: res.data };
                });
            }
        } catch (error) {
            console.error('Error fetching activities:', error);
        }
    }
);

export const getConstructionProgressList = atom(
    null,
    async (get, set) => {
        try {
            const res = await getConstructionProgress();
            if (res) {
                set(reportsAtoms, (prev) => {
                    return { ...prev, progressList: res.data };
                });
            }
        } catch (error) {
            console.error('Error fetching construction progress:', error);
        }
    }
);

export const fetchSummaryList = atom(
    null,
    async (get, set, payload) => {
        try {
            const res = await getSummaryData(payload);
            if (res) {
                set(reportsAtoms, (prev) => {
                    return { ...prev, summaryData: res.data };
                });
            }
        } catch (error) {
            console.error('Error fetching summary data:', error);
        }
    }
);

export const fetchInstallStatsReportAtom = atom(
    null,
    async (get, set) => {
        try {
            const res = await getInstallStatsReport();
            if (res) {
                set(reportsAtoms, (prev) => {
                    return { ...prev, statsData: res.data };
                });
            }
        } catch (error) {
            console.error('Error fetching install stats report:', error);
        }
    }
);

export const fetchInstallStatsDownloadReportAtom = atom(
    null,
    async (get, set) => {
        try {
            const res = await getInstallStatsDownloadReport();
            if (res) {
                set(reportsAtoms, (prev) => {
                    return { ...prev, statsData: res.data };
                });
            }
        } catch (error) {
            console.error('Error fetching install stats download report:', error);
        }
    }
);

export const fetchTrackerDataAtom = atom(
    null,
    async (get, set) => {
        try {
            const [trackerRes, blockNamesRes] = await Promise.all([
                getTrackerData(),
                getBlockNames()
            ]);

            if (trackerRes && blockNamesRes) {
                set(reportsAtoms, (prev) => {

                    return {
                        ...prev,
                        trackerData: trackerRes.data,
                        blockNames: blockNamesRes.data
                    };
                });
            }
        } catch (error) {
            console.error('Error fetching tracker data:', error);
        }
    }
);

export const fetchPartsDataAtom = atom(
    null,
    async (get, set) => {
        try {
            
            const [partsRes, blockNamesRes, partDetailsRes] = await Promise.all([
                getBomRequiredBlockWise(),
                getBlockNames(),
                getPartDetails()
            ]);
            
            if (partsRes && blockNamesRes && partDetailsRes) {
                set(reportsAtoms, (prev) => {
                    const newState = {
                        ...prev,
                        partsData: partsRes.data,
                        blockNames: blockNamesRes.data,
                        partDetails: partDetailsRes.data
                    };
                    return newState;
                });
            }
        } catch (error) {
            console.error('Error fetching parts data:', error);
        }
    }
);


export const fetchSummarizedInventoryDataAtom = atom(
  null,
  async (get, set, args) => {
    try {
      const data = await getSummarizedInventoryData(args);

      set(reportsAtoms, (prev) => ({ ...prev,
        summarizedInventoryData: data
      }));

      return data;
    } catch (error) {
      console.error("Error fetching summarized inventory data:", error);
      throw error;
    }
  }
);
export default reportsAtoms;